// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_82b43b37","outerContainer":"_7e2b578d","secondaryToolbar":"_37183907","doorHangerRight":"c1b87036","toolbarContainer":"b12813e3","toolbarViewerMiddle":"_6f639268","progressBar":"_1ad05613","back-to-application":"_03f3ba1b","root":"b51adc31","back-btn":"a98f6bf1","payment-view":"_4474ec69","loading":"_5918d8af","header":"_468a6771","header--title":"_48353c35"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Healthboard/Components/PayaPayment/styles.styl
// module id = 4977
// module chunks = 39